import kamala from '../../kamala'
import Affix from './Affix'

Affix.install = function (Vue) {
  kamala(Vue)
  Vue.component(Affix.name, Affix)
}

export default Affix
